import React from 'react';
import { string, func } from 'prop-types';
import { Options } from 'ps-design';

import './DisplayValueSwitcher.scss';

const options = ['Monetary', 'Percentage'];

class DisplayValueSwitcher extends React.Component {
  static propTypes = {
    displayChartIn: string,
    handleOnChange: func
  };

  render() {
    const { displayChartIn, handleOnChange } = this.props;

    return (
      <div className="year-over-year-chart__switcher">
        <p className="pxl-text-xsmall">View chart in</p>
        <Options
          value={displayChartIn}
          options={options}
          onChange={handleOnChange}
          syncOptions={false}
          type="radio"
          multiValue={false}
          className={`pxl-option-primary options__radio-btn`}
          loadMore={false}
        />
      </div>
    );
  }
}

export default DisplayValueSwitcher;
